export function setStatic(key, value) {
    return {
        staticCallback: function (componentClass) {
            componentClass[key] = value;
        },
    };
}
export default setStatic;

//# sourceMappingURL=setStatic.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/setStatic.js
// module id = 8
// module chunks = 0